import { useWithdraw } from '@/api/auth'
import { useAuthContext } from '@/context/AuthContext'
import Modal from '@/components/common/Modal'
import { Popup, type PopupProps } from '@collable/ui'

interface WithdrawModalProps {
  onClose: () => void
}

const WithdrawModal = ({ onClose }: WithdrawModalProps) => {
  const { actions } = useAuthContext()
  const { mutate: withdraw, isPending } = useWithdraw()

  const handleWithdraw = () => {
    withdraw(
      undefined, // 현재는 빈 문자열로 전송, 추후 필요 시 사유 입력 폼 추가 가능
      {
        onSuccess: () => {
          // 회원탈퇴 성공 후 로그아웃 처리
          actions.signOut()
          onClose()
        },
      },
    )
  }

  const popupProps: PopupProps = {
    title: '회원탈퇴',
    description: '정말로 회원탈퇴를 하시겠습니까?\n탈퇴 후에는 복구가 불가능합니다.',
    variant: 'twoBtn',
    actionBtnText: isPending ? '처리중...' : '탈퇴하기',
    cancelBtnText: '취소',
    onClickActionBtn: handleWithdraw,
    onClose,
  }

  return (
    <Modal onClose={onClose}>
      <Popup {...popupProps} />
    </Modal>
  )
}

export default WithdrawModal
